__webpack_require__.p = "/redactor-quote-to-heading/onboarding/";